import tw from 'twin.macro';

export const BackDrop = tw.div`fixed inset-0 bg-darkGray opacity-40`;
